import Amplify from 'aws-amplify';
import { dynamicAWSConfig, ENVCONFIG } from 'src/helpers/dynamicAWSConfig';

export const awsConfigure = (config: ENVCONFIG): void => {
  Amplify.configure(dynamicAWSConfig(config));
};
